<h1>Медиа</h1>
<mtg-tournament-media
  [games]="games"
  [loading]="loading"
  [tournaments]="tournaments"
  [mediaRoute]="leagueMediaRouteDetail"
  [headerStickyTop]="headerHeight"
  [sport]="league.sport"
  (nextPage)="loadNextPage()"
  (filterChanged)="setFilter($event)"
></mtg-tournament-media>
<router-outlet></router-outlet>
